import * as React from 'react';
import { ThumbDown, ThumbUp, ThumbDownAltOutlined, ThumbUpAltOutlined } from '@mui/icons-material';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Card, Chip } from '@mui/material';
export const SuggestionAcceptReject: React.FC<{
    radioValue?: string;
    textValue?: string;
    loggedUser?: string;
    acceptUserId?: any;
    rejectUserId?: any;
    IsSuggestionAccepted: boolean;
    IsSuggestionRejected: boolean;
    canEdit: boolean;
    dataAnalyticsSuggestion?: string;
    userRejectBox?: any;
    resetConfirmation: any;
    userAcceptConfirm: any;
    userEditForm: any;
    isAcceptedSuggestion?: string;
    rejectedUserSuggestions?: string;
}> = (props) => {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const [isAcceptedAction, setAcceptedAction] = React.useState(props.IsSuggestionAccepted);
    const [isRejectedAction, setRejectedAction] = React.useState(props.IsSuggestionRejected);
    const [isCanEditAction, setCanEditAction] = React.useState(props.canEdit);
    const [isLoggedUserAction, setLoggedUserAction] = React.useState(props.loggedUser);
    const [isAcceptedUserId, setAcceptedUserId] = React.useState(props.acceptUserId);
    const [isDataAnalyticsSuggestion, setDataAnalyticsSuggestion] = React.useState(props.dataAnalyticsSuggestion);
    const [isTitleDescription, setTitleDescription] = React.useState(props.textValue);
    const [isRejectedUserId, setRejectedUserId] = React.useState(props.rejectUserId);
    const [radiovalues, setRadioValue] = React.useState(props.radioValue);
    const classes = chartLabelNameStyle();
    const { t } = useLanguageLocale();
    React.useEffect(() => {
        setAcceptedAction(props.IsSuggestionAccepted);
        setRejectedAction(props.IsSuggestionRejected);
        setCanEditAction(props.canEdit);
        setLoggedUserAction(props.loggedUser);
        setAcceptedUserId(props.acceptUserId);
        setDataAnalyticsSuggestion(props.dataAnalyticsSuggestion);
        setTitleDescription(props.textValue);
        setRejectedUserId(props.rejectUserId);
        setRadioValue(props.radioValue);
    }, []);

    const rejectedForm = (actionType: boolean): void => {
        props.userRejectBox(true, actionType);
        setAcceptedAction(false);
        setRejectedAction(true);
        setCanEditAction(true);
    };

    const acceptedForm = (actionType: boolean): void => {
        props.userAcceptConfirm(actionType);
        setAcceptedAction(true);
        setRejectedAction(false);
        setCanEditAction(true);
    };

    const userRejectEditForm = (actionType: boolean): void => {
        props.userEditForm(true, actionType);
    };

    const resetSuggestion = (actionType: boolean): void => {
        props.resetConfirmation(actionType);
    };

    let alarmNotifyContent;

    if (props.dataAnalyticsSuggestion !== undefined) {
        if (!props.IsSuggestionRejected && !props.IsSuggestionAccepted) {
            alarmNotifyContent = (
                <Card data-testid="Suggestion-Variation" className={classes.alarmSuggBox}>
                    <div className={classes.SuggTitle}>{isDataAnalyticsSuggestion}</div>
                    <span className={classes.SuggContent}>
                        <ThumbUpAltOutlined
                            data-testid="Accepted-form"
                            onClick={(): void => acceptedForm(true)}
                            className={classes.thumdw}
                            style={{ marginRight: '20px' }}
                        />
                        <ThumbDownAltOutlined
                            data-testid="Rejected-form"
                            onClick={(): void => rejectedForm(true)}
                            className={classes.thumdw}
                        />
                    </span>
                </Card>
            );
        }
        if (!props.IsSuggestionRejected && props.IsSuggestionAccepted && props.canEdit) {
            if (props.loggedUser === props.acceptUserId) {
                alarmNotifyContent = (
                    <Card data-testid="Suggestion-Variation" className={classes.alarmSuggBox}>
                        <div className={classes.SuggTitle}>{isDataAnalyticsSuggestion}</div>
                        <span className={classes.SuggContent}>
                            <ThumbUp
                                onDoubleClick={(): void => resetSuggestion(true)}
                                className={classes.thumdw}
                                style={{ marginRight: '20px' }}
                            />
                            <ThumbDownAltOutlined className={classes.thumdw} />
                        </span>
                    </Card>
                );
            } else if (props.loggedUser !== props.acceptUserId) {
                alarmNotifyContent = (
                    <Card className={classes.alarmSuggBox} data-testid="Suggestion-Variation" style={{ width: '100%' }}>
                        <span className={classes.SuggTitle}>{props.isAcceptedSuggestion}</span>
                        <span className={classes.SuggContent}>
                            <Chip icon={<ThumbUpAltOutlined />} size="medium" color="primary" label="Accepted" />
                        </span>
                    </Card>
                );
            }
        }

        if (props.IsSuggestionRejected && !props.IsSuggestionAccepted && props.canEdit) {
            if (props.loggedUser === props.rejectUserId) {
                alarmNotifyContent = (
                    <Card className={classes.alarmSuggBox} data-testid="Suggestion-Variation">
                        <div className={classes.SuggTitle}>
                            {`You classified this activity as "${props.radioValue}"`}.
                            <a
                                onClick={(): void => userRejectEditForm(true)}
                                style={{ cursor: 'pointer', color: '#007bc1', fontWeight: 600 }}
                            >
                                {' '}
                                Edit Details
                            </a>
                            <br />
                            <span style={{ fontStyle: 'italic' }}>{props.textValue}</span>
                        </div>
                        <span className={classes.SuggContent}>
                            <ThumbUpAltOutlined className={classes.thumdw} style={{ marginRight: '20px' }} />
                            <ThumbDown onDoubleClick={(): void => resetSuggestion(true)} className={classes.thumdw} />
                        </span>
                    </Card>
                );
            } else {
                alarmNotifyContent = (
                    <Card className={classes.alarmSuggBox} data-testid="Suggestion-Variation" style={{ width: '100%' }}>
                        <div className={classes.SuggTitle}>
                            {`You classified this activity as "${props.radioValue}"`}.<br />
                            <span style={{ fontStyle: 'italic' }}>{props.rejectedUserSuggestions}</span>
                        </div>
                        <span className={classes.SuggContent}>
                            <Chip icon={<ThumbDownAltOutlined />} size="medium" color="primary" label="Rejected" />
                        </span>
                    </Card>
                );
            }
        }

        if (!props.IsSuggestionRejected && props.IsSuggestionAccepted && !props.canEdit) {
            alarmNotifyContent = (
                <Card className={classes.alarmSuggBox} style={{ width: '100%' }} data-testid="Suggestion-Variation">
                    <span className={classes.SuggTitle}>{props.isAcceptedSuggestion}</span>
                    <span className={classes.SuggContent}>
                        <Chip icon={<ThumbUpAltOutlined />} size="medium" color="primary" label="Accepted" />
                    </span>
                </Card>
            );
        }

        if (!props.IsSuggestionAccepted && props.IsSuggestionRejected && !props.canEdit) {
            alarmNotifyContent = (
                <Card className={classes.alarmSuggBox} style={{ width: '100%' }} data-testid="Suggestion-Variation">
                    <div className={classes.SuggTitle}>
                        {`You classified this activity as "${props.radioValue}".`}
                        <br />
                        <span style={{ fontStyle: 'italic' }}>{props.textValue}</span>
                    </div>
                    <span className={classes.SuggContent}>
                        <Chip icon={<ThumbDownAltOutlined />} size="medium" color="primary" label="Rejected" />
                    </span>
                </Card>
            );
        }
    } else {
        alarmNotifyContent = <></>;
    }
    return <div data-testid="alarmNotifyContent">{alarmNotifyContent}</div>;
};
